import type { Modifier, ModifierDetail } from '@/domain/entities/modifier.entity'
import type { ModifierDetailDto, ModifierDto } from './modifier.dto'

export const modifierMapper = {
  toModifier(dto: ModifierDto): Modifier {
    return {
      id: dto.id,
      name: dto.name,
      sku: dto.sku ?? null,
      sourceId: dto.source_id || null,
      price1: dto.price1 ?? 0,
      price2: dto.price2 ?? 0,
      price3: dto.price3 ?? 0,
      manualHpp: dto.manual_hpp ?? null,
      // BE hanya mengirim yang aktif di list biasa; anggap aktif bila absen.
      active: dto.active ?? true,
      ownerProductId: dto.owner_product_id || null,
    }
  },

  toModifierDetail(dto: ModifierDetailDto): ModifierDetail {
    return {
      ...modifierMapper.toModifier(dto),
      // BE membedakan field hilang (endpoint tak menyediakan) dari [] (belum
      // ditautkan). Di sisi FE keduanya sama-sama "belum ada tautan".
      productIds: dto.product_ids ?? [],
    }
  },
}
